const previews = new Map<string, HTMLCanvasElement>();
const MAX_PREVIEW_EDGE = 4096;

export function getGrayscalePreview(image: HTMLImageElement, assetId: string): HTMLCanvasElement {
  const cached = previews.get(assetId);
  if (cached) return cached;

  const scale = Math.min(1, MAX_PREVIEW_EDGE / Math.max(image.naturalWidth, image.naturalHeight));
  const canvas = window.document.createElement('canvas');
  canvas.width = Math.max(1, Math.round(image.naturalWidth * scale));
  canvas.height = Math.max(1, Math.round(image.naturalHeight * scale));
  const context = canvas.getContext('2d');
  if (!context) return imageToCanvas(image);
  context.filter = 'grayscale(1)';
  context.drawImage(image, 0, 0, canvas.width, canvas.height);
  previews.set(assetId, canvas);
  return canvas;
}

function imageToCanvas(image: HTMLImageElement): HTMLCanvasElement {
  const canvas = window.document.createElement('canvas');
  canvas.width = image.naturalWidth;
  canvas.height = image.naturalHeight;
  canvas.getContext('2d')?.drawImage(image, 0, 0);
  return canvas;
}
